import React from 'react'
import { useIntl } from 'gatsby-plugin-intl'
import Layout from '../components/Layout/index'
import Header from '../modules/Header'
import Footer from '../modules/Footer'
import ImprintPage from '../components/StaticPages/ImprintPage'
import SEO from '../components/seo'
import messages from '../messages/pageTitles.lang'
import metaDescription from '../messages/pageMetaDescriptions.lang'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleImprint)}
        description={formatMessage(metaDescription.imprintDescription)}
        lang={locale}
      />
      <ImprintPage />
    </Layout>
  )
}

export default IndexPage
